/// <reference types="@angular/localize" />

// Only the Bootstrap plugins driven by data-bs-* markup; its dropdown plugin crashes on ngbDropdown menus.
import "bootstrap/js/src/collapse.js";
import "bootstrap/js/src/tab.js";

import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { AdaaComponent } from "./app/app";
import { appConfig } from "./app/app-config";
import { environment } from "./app/core/environments/environment";

if (environment.production) {
  enableProdMode();
}

// eslint-disable-next-line no-console
bootstrapApplication(AdaaComponent, appConfig).catch((err) => console.error(err));
